import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-ag-mat-checkbox',
  templateUrl: './ag-mat-checkbox.component.html',
  styleUrls: ['./ag-mat-checkbox.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgMatCheckboxComponent),
      multi: true,
    },
  ],
})
export class AgMatCheckboxComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() tooltip: string = '';
  @Input() idTooltip: string = '';
  @Input() id: string = '';
  @Input() value: any = '';
  @Input() ngModelChange: any;
  @Input() disabled: boolean = false;

  // Usando um método getter e setter para acessar a innerValue
  private _innerValue: any;

  get innerValue(): any {
    return this._innerValue;
  }

  set innerValue(value: any) {
    this._innerValue = value;
    this.onChange(value); // Notifica o Angular sobre as mudanças
  }

  constructor() {}

  writeValue(value: any) {
    this.innerValue = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onChange = (value: any) => {};
  onTouched = () => {};

  // Quando o valor muda dentro do componente, atualize o valor interno
  onValueChange(value: any) {
    // console.log(value)
    this.innerValue = value;
  }

  // Define uma função para tratar a mudança do ngModel, se necessário
  onNgModelChange(event: any) {
    this.ngModelChange(event);
  }
}
